import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import classes from './Autocomplete.module.css';
import TimesCircleIcon from 'assets/images/times-circle.svg';

class LocationSearchInput extends Component {
  constructor(props) {
    super(props);
    this.locationInput = React.createRef();
    this.state = { address: '' };
  }

  componentDidMount() {
    this.setState({ address: this.props.address });
    this.locationInput.current.focus();
    if (typeof window !== 'undefined') {
      this.placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.address !== prevProps.address) this.setState({ address: this.props.address });
  }

  handleChange = (address) => {
    this.setState({ address });
  };

  handleLocationDeletion = () => {
    this.setState({ address: '' });
    this.props.handleLocationDeletion();
  };

  toggleImportantPlaceForm = () => {
    if (this.props.address && !this.props.isImportantPlace) {
      this.props.toggleImportantPlaceForm();
    }
  };

  handleSelect = (address, placeId) => {
    geocodeByAddress(address)
      .then((results) => {
        return getLatLng(results[0]);
      })
      .then((latLng) => {
        this.placesService.getDetails({ placeId }, (result) => {
          let locationLine1 = '';
          let locationLine2 = result.formatted_address;
          const addressOnlyLocationTypes = ['premise', 'street_address', 'political'];
          const isNamelessAddress = result.types.some((type) => addressOnlyLocationTypes.indexOf(type) >= 0);
          if (!isNamelessAddress) {
            locationLine1 = result.name;
            locationLine2 = result.formatted_address.includes(result.name)
              ? result.formatted_address.replace(`${result.name}, `, '')
              : result.formatted_address;
          }
          this.props.handleLocationUpdate(locationLine1, locationLine2, latLng, latLng, null, null, null, null, null, false, null);
          this.setState({ address });
        });
      })
      .catch((error) => console.error('Error', error));
  };

  // onBlur() {
  //   const { address, placeId } = this.state;
  // }

  render = () => {
    const addImportantPlaceIconClasses = [classes.AddImportantPlaceIcon];
    if (!this.props.address || this.props.isImportantPlace) addImportantPlaceIconClasses.push(classes.Disabled);
    return (
      <div className={classes.Container}>
        <PlacesAutocomplete value={this.state.address} onChange={this.handleChange} onSelect={this.handleSelect} onBlur={this.onBlur}>
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div>
              <div className={classes.InputContainer}>
                <div className={classes.InputContainerTop}>
                  <FontAwesomeIcon icon="plus" onClick={this.toggleImportantPlaceForm} className={addImportantPlaceIconClasses.join(' ')} />
                </div>

                <div className={classes.InputContainerInner}>
                  <input
                    className={classes.LocationSearchInput}
                    ref={this.locationInput}
                    {...getInputProps({
                      placeholder: 'Enter an address or choose from below',
                      className: classes.LocationSearchInput,
                      ref: this.locationInput,
                    })}
                  />
                  {this.props.address.length > 0 ? (
                    <img src={TimesCircleIcon} alt="delete-location" onClick={this.handleLocationDeletion} className={classes.DeleteLocation} />
                  ) : null}
                </div>
              </div>
              <div
                style={suggestions.length > 0 ? { backgroundColor: '#fafafa', minHeight: '200px' } : null}
                className={classes.AutocompleteDropdownContainer}
              >
                {loading && <div>Loading...</div>}
                {suggestions.map((suggestion) => {
                  // const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: 'rgba(0,0,0,.1)', width: '340px' }
                    : { backgroundColor: '#fafafa', width: '340px' };
                  return (
                    <div
                      key={suggestion.description}
                      {...getSuggestionItemProps(suggestion, {
                        style,
                      })}
                      className={classes.Selection}
                    >
                      <span className={classes.SelectionDescription}>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
      </div>
    );
  };
}

export default LocationSearchInput;
